import { Link, useNavigate } from "react-router-dom";
import { reg_doodle, textLogo } from "../../constant/import";
import { Button, InputField } from "../../components/forms";
import { emailReg, numReg, textReg } from "../../utils/regex";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { IoMdClose } from "react-icons/io";
import { onCreateUser, onGetOtp } from "../../services/auth/user";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { FaCheck, FaInfo } from "react-icons/fa";
import { toast } from "react-toastify";

const RegisterAccount = () => {
  const { handleSubmit, control, watch } = useForm();
  const { isTabletOrMobile } = useStateGetter();
  const { showModal, setShowModal, setVerifyEmail } = useStateSetter();
  const navigate = useNavigate();
  const [confpass, setconfpass] = useState("");
  const [pass, setpass] = useState("");
  const watchedemail = watch(["email"]);

  const watchedFields = watch([
    "firstname",
    "lastname",
    "phone",
    "email",
    "password",
    "conpassword",
  ]);
  const LoginAlertAction = () => (
    <div className=" flex flex-col justify-center items-center">
      <p className=" font-medium text-textbg  my-2">
  
        Email Verification required{" "}
      </p>
      <p className="font-light text-textbg  text-xs text-center">
 
         Your email needs to be verified, we will send a One Time Password (OTP)
        to your email
      </p>
      <div className=" gap-6 w-full flex ">
        <Button
          outlined
          disabled={false}
          text="cancel"
          onBtnClick={() => {
            setShowModal(false);
          }}
        />
        <Button
          disabled={false}
          text="Get OTP"
          onBtnClick={async () => {
            setLoading(true);
            var postdata = { email: watchedemail[0] };
            setVerifyEmail(watchedemail[0]);
            var res = await onGetOtp(postdata);
            setLoading(false);
            toast("OTP sent to your email");
            navigate("/verify");
            setShowModal(false);
          }}
        />
      </div>{" "}
    </div>
  );
  const OncreatesuccessAction = () => (
    <div className="">
      <p className=" font-medium text-textbg  my-2">
        {" "}
        New Account Created Successsfuly{" "}
      </p>
      <div className=" gap-6 w-full flex ">
        <Button
          disabled={false}
          text="Verify Email"
          onBtnClick={() => {
            showModal(
              "",
              "",
              <FaInfo
                size={40}
                className="inline text-textbg p-2 rounded-full bg-faint"
              />,
              <LoginAlertAction />
            );
          }}
        />
      </div>{" "}
    </div>
  );
  const { setLoading } = useStateSetter();
  const wacthpasswordfild = watch(["password"]);
  const wacthconfpasswordfild = watch(["conpassword"]);

  const isvalidpassword = wacthpasswordfild.every(
    (pass) =>
      !(pass?.length < 6) &&
      /\d/.test(pass) &&
      /[!@#$%^&*(),.?":{}|<>]/.test(pass)
  );
  const areFieldsFilled = watchedFields.every(
    (field) =>
      field !== "" && field !== undefined && isvalidpassword && confpass == pass
  );

  useEffect(() => {
    setconfpass(wacthconfpasswordfild[0]);
  }, [wacthconfpasswordfild]);

  useEffect(() => {
    setpass(wacthpasswordfild[0]);
  }, [wacthpasswordfild]);

  const onchange = () => {
    console.log(areFieldsFilled);
  };
  const onSubmit = async (data) => {


    
    setLoading(true);
    try {
      const postdata = {
        firstName: data.firstname,
        lastName: data.lastname,
        email: data.email,
        phoneNumber: data.phone,
        password: data.password,
        // createdBy: "self",
        // userType: "Owner",
      };

      const responsse = await onCreateUser(postdata);

      if (responsse.success) {
        showModal(
          "",
          "",
          <FaCheck
            size={30}
            className="inline  text-textbg bg-green-200 p-2 rounded-full"
          />,
          <OncreatesuccessAction />
        );
      }
      console.log(responsse);
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error(error);
    }
    setLoading(false);
  };

  return (
    <div className="p-4 md:p-10 w-screen h-screen bg-customGray  flex flex-col md:grid md:grid-cols-2 items-center justify-center">
      {!isTabletOrMobile && (
        <div className="px-30 py-10 flex flex-col gap-10 justify-center items-center ">
          <img className="w-[173px] mb-4 " src={textLogo} />
          <img className="w-[330px]  " src={reg_doodle} />
        </div>
      )}
      <div className="bg-white  w-[100%] md:w-[458px] p-6   overflow-y-scroll h-screen pb-20 overflow-x-hidden  md:mx-20 md:py-4 md:px-20 shadow flex flex-col  ">
        {isTabletOrMobile && (
          <img className="w-[173px] self-center my-12  " src={textLogo} />
        )}

        <p className="font-bold text-textbg text-[27px] md:text-[24px]">
          Create Account
        </p>
        <small className="font-medium text-textbg text-sm md:text-xs">
          Already have an account?{" "}
          <Link className="text-primary" to="/">
            Login{" "}
          </Link>
        </small>

        <div className=" my-2">
          <InputField
            name="firstname"
            onchange={onchange}
            title="First name"
            placeholder="First name"
            control={control}
            rules={{
              required: "First name is required",
              pattern: {
                value: textReg,
                message: "Invalid name",
              },
            }}
          />
          <InputField
            name="lastname"
            title="Last name"
            placeholder="Last name"
            onchange={onchange}
            control={control}
            rules={{
              required: "Last name is required",
              pattern: {
                value: textReg,
                message: "Invalid name",
              },
            }}
          />
          <InputField
            name="phone"
            title="Phone number"
            placeholder="Enter phone number"
            control={control}
            rules={{
              required: "Phone number is required",
              pattern: {
                value: numReg,
                message: "Invalid phone number",
              },
            }}
          />
          <InputField
            name="email"
            title="Email Address"
            onchange={onchange}
            placeholder="Enter Email Address"
            control={control}
            rules={{
              required: "Email Address is required",
              pattern: {
                value: emailReg,
                message: "Invalid Email Address",
              },
            }}
          />
          <InputField
            name="password"
            title="Password"
            onchange={onchange}
            placeholder="Enter Your Password"
            control={control}
            rules={{
              required: "Password is required",
            }}
            type={"password"}
          />
          <InputField
            name="conpassword"
            title="Confirm Password"
            placeholder="Confirm Your Password"
            control={control}
            onchange={onchange}
            rules={{
              required: "Password is required",
            }}
            type={"password"}
          />
          {pass && (
            <div className=" p-3 m-2">
              <p className="text-xs m-1">
                {!(pass ? pass?.length < 6 : true) ? (
                  <FaCheck className="inline text-green-400" />
                ) : (
                  <IoMdClose className=" text-red-500 inline" />
                )}{" "}
                6 characters minimum
              </p>

              <p className="text-xs m-1">
                {!/\d/.test(pass) ? (
                  <IoMdClose className=" text-red-500 inline" />
                ) : (
                  <FaCheck className="inline text-green-400" />
                )}{" "}
                Contains a number
              </p>

              <p className="text-xs m-1">
                {!/[!@#$%^&*(),.?":{}|<>]/.test(pass) ? (
                  <IoMdClose className=" text-red-500 inline" />
                ) : (
                  <FaCheck className="inline text-green-400" />
                )}{" "}
                Atleast one special character
              </p>
            </div>
          )}
          {!(confpass == pass) && (
            <p className="text-xs text-center text-red-500">
              {" "}
              <IoMdClose className=" text-red-500 inline" /> Passwords don't
              match
            </p>
          )}
          <Button
            disabled={!areFieldsFilled}
            text="Create"
            onBtnClick={handleSubmit(onSubmit)}
          />
          <div className=" w-full flex justify-center items-center">
            <small className=" text-textbg font-light text-sm md:text-xs w-full text-center ">
              By creating an account you agree to RWND Engage's{" "}
              <Link className="text-primary" to="/">
                Terms of use & Privacy policy
              </Link>
            </small>
          </div>{" "}
        </div>
      </div>
    </div>
  );
};

export { RegisterAccount };
